import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Button,
  Grid,
  Form,
  Segment,
  Divider
} from 'semantic-ui-react';

import * as AppActions from '../../actions';
import LoginLinks from './LoginLinks'

class ConfirmNewUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      message: '',
      password: '',
      changePassword: '',
      confirmPassword: '',
    };
  }

  componentDidMount() {
    this.init();
  }

  init = () => {
    const code = window.location.search.split('code=')[1] ? window.location.search.split('code=')[1] : '';
    this.setState({ password: code });
  }

  login = async (event) => {
    event.preventDefault();
    const { actions, user } = this.props;
    const { username, password, changePassword, confirmPassword } = this.state;

    if (user.loading) return;

    if (!username || !password || !changePassword || !confirmPassword) {
      this.setState({ message: 'All the fields are required' });
      return;
    }

    if (changePassword !== confirmPassword) {
      this.setState({ message: 'Please make sure both your passwords are identical.' });
      return;
    }

    if (!changePassword.match('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')) {
      this.setState({ message: 'Please make sure your password is at least 8 characters long, has upper and lower case characters, a number, and a special character.' });
      return;
    }

    try {
      await actions.login({ username, password, changePassword });
    } catch (error) {
      console.log(error);
      this.setState({message: error.message});
    }
  };

  loginForm = () =>
    (<div className="container">
      <div className="">
        <Grid>
          <Grid.Column>
            <Segment className="rounded-container">
              <Form className="Login-form" onSubmit={this.login}>
                <Form.Field>
                  <input
                    placeholder="Username"
                    id="username"
                    onChange={event => this.setState({ username: event.target.value })}
                    className="format-login-input"
                    type="text"
                  />
                </Form.Field>
                <Form.Field>
                  <input
                    placeholder="Temp Password"
                    id="password"
                    onChange={event => this.setState({ password: event.target.value })}
                    className="format-login-input"
                    value={this.state.password}
                    type="password"
                  />
                </Form.Field>
                <Form.Field>
                  <input
                    placeholder="New Password"
                    id="password"
                    onChange={event => this.setState({ changePassword: event.target.value })}
                    className="format-login-input"
                    type="password"
                  />
                </Form.Field>
                <Form.Field>
                  <input
                    placeholder="Confirm password"
                    id="confirmPassword"
                    onChange={event => this.setState({ confirmPassword: event.target.value })}
                    type="password"
                    className="format-login-input"
                  />
                </Form.Field>
                <Divider hidden />
                <Button type="submit" color="black" className="login-button" fluid>
                  Reset Password and Login
                </Button>
              </Form>
              <Divider hidden />
              <LoginLinks handleSwitchForm={this.props.handleSwitchForm} />
              <div className="login-error">
                {this.state.message}
              </div>
            </Segment>

          </Grid.Column>
        </Grid>
      </div>
    </div>);

  render() {
    return this.loginForm();
  }
  }

  const mapStateToProps = state => ({
    user: state.user,
  });

  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(AppActions, dispatch),
  });

  export default connect(mapStateToProps, mapDispatchToProps)(ConfirmNewUser);



// WEBPACK FOOTER //
// ./src/screens/Auth/ConfirmNewUser.js